import { API_SERVICE } from '../../../utils/apiService';
import { CALL_API } from '../../api';
export const INVITE_MEMBER_REQUEST = 'INVITE_MEMBER_REQUEST';
export const TEAM_MEMBERS_REQUEST = 'TEAM_MEMBERS_REQUEST';
export const TEAM_MEMBERS_RESPONSE = 'TEAM_MEMBERS_RESPONSE';
export const INVITE_MEMBER_RESPONSE = 'INVITE_MEMBER_RESPONSE';
export const UPDATE_INVITATION_REQUEST = 'UPDATE_INVITATION_REQUEST';
export const INVITE_MEMBER_TOKEN_VALIDATION_REQUEST =
    'INVITE_MEMBER_TOKEN_VALIDATION_REQUEST';
export const UPCOMING_EVENTS_REQUEST = 'UPCOMING_EVENTS_REQUEST';
export const TEAM_MEMBER_ADDON_ESTIMATE_REQUEST =
    'TEAM_MEMBER_ADDON_ESTIMATE_REQUEST';
export const TEAM_MEMBER_ADDON_PURCHASE_REQUEST =
    'TEAM_MEMBER_ADDON_PURCHASE_REQUEST';
export const TEAM_MEMBER_ADDON_REDUCE_SEATS_REQUEST =
    'TEAM_MEMBER_ADDON_REDUCE_SEATS_REQUEST';
export const TEAM_MEMBER_BULK_DELETE_REQUEST =
    'TEAM_MEMBER_BULK_DELETE_REQUEST';

export function inviteMember(payload) {
    return {
        [CALL_API]: {
            types: [INVITE_MEMBER_REQUEST],
            endpoint: `/airmeet/community/team-member/invite`,
            body: {
                ...payload,
            },
            type: 'json',
            method: 'POST',
            service: API_SERVICE.BFF,
        },
    };
}

export function validateInvitation(payload) {
    return {
        [CALL_API]: {
            types: [INVITE_MEMBER_TOKEN_VALIDATION_REQUEST],
            endpoint: '/airmeet/community/team-member/invite/validity',
            body: {
                ...payload,
            },
            type: 'json',
            method: 'POST',
            service: API_SERVICE.BFF,
        },
    };
}
export function updateInvitation(payload) {
    return {
        [CALL_API]: {
            types: [UPDATE_INVITATION_REQUEST],
            endpoint: '/airmeet/community/team-member/invite',
            body: {
                ...payload,
            },
            type: 'json',
            method: 'PUT',
            service: API_SERVICE.BFF,
        },
    };
}

export function fetchCommunityTeamMembers(communityId) {
    return {
        [CALL_API]: {
            types: [TEAM_MEMBERS_REQUEST],
            endpoint: `/airmeet/community/${communityId}/team-members`,
            method: 'GET',
            service: API_SERVICE.BFF,
        },
    };
}

export function memberEventsList(payload) {
    const { communityKey: communityId, email } = payload;
    return {
        [CALL_API]: {
            types: [UPCOMING_EVENTS_REQUEST],
            endpoint: `/airmeet/community/events`,
            body: {
                communityId,
                managerEmail: email,
            },
            type: 'json',
            method: 'POST',
        },
    };
}

export function teamMemberAddonEstimates(payload) {
    const { communityId, addonSeatsCount } = payload;
    return {
        [CALL_API]: {
            types: [TEAM_MEMBER_ADDON_ESTIMATE_REQUEST],
            endpoint: `/airmeet/community/${communityId}/subscription/add-on/estimate`,
            body: {
                addons_to_be_added: [
                    {
                        type: 'TEAM_MEMBER',
                        quantity: addonSeatsCount,
                    },
                ],
            },
            type: 'json',
            method: 'POST',
            service: API_SERVICE.BFF,
        },
    };
}

export function purchaseTeamMemberAddon(payload) {
    return {
        [CALL_API]: {
            types: [TEAM_MEMBER_ADDON_PURCHASE_REQUEST],
            endpoint: '/community/subscription/add-on/team-members',
            body: {
                ...payload,
            },
            type: 'json',
            method: 'POST',
            service: API_SERVICE.BFF,
        },
    };
}

export function updateAddonSeatsCount(payload) {
    const { community_id, no_of_seats } = payload;
    return {
        [CALL_API]: {
            types: [TEAM_MEMBER_ADDON_REDUCE_SEATS_REQUEST],
            endpoint: '/community/subscription/add-on/team-members',
            body: {
                community_id,
                no_of_seats,
            },
            type: 'json',
            method: 'PUT',
            service: API_SERVICE.BFF,
        },
    };
}

export function deleteTeamMembers(payload) {
    const {
        communityId,
        eventManagersToBeRemoved,
        invitedMembersToBeRemoved,
    } = payload;
    return {
        [CALL_API]: {
            types: [TEAM_MEMBER_BULK_DELETE_REQUEST],
            endpoint: `/airmeet/community/${communityId}/team-members`,
            body: {
                confirmed: [...eventManagersToBeRemoved],
                unconfirmed: [...invitedMembersToBeRemoved],
            },
            type: 'json',
            method: 'DELETE',
            service: API_SERVICE.BFF,
        },
    };
}
